import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class StallTypeApi {
  getStallTypes = async () => {
    try {
      const response = await api.get("/stall-type");
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };

  saveStallType = async (data) => {
    try {
      const response = await api.post("/stall-type", data);
      if (response.status === 200 || response.status === 201) {
        // ShowNotifications.showAlertNotification("Stall Type Added Successfully", true);
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to add stall type";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  updateStallType = async (id, data) => {
    try {
      const response = await api.put(`/stall-type/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        ShowNotifications.showAlertNotification("Stall Type Updated Successfully", true);
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to update stall type";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  deleteStallType = async (id) => {
    try {
      const response = await api.delete(`/stall-type/${id}`);
      if (response.status === 200 || response.status === 201) {
        // ShowNotifications.showAlertNotification("Stall Type Deleted Successfully", true);
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to delete stall type";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const stallTypeApi = new StallTypeApi();
export default stallTypeApi;

export const {
  getStallTypes,
  saveStallType,
  updateStallType,
  deleteStallType,
} = stallTypeApi;
